module.exports = __webpack_public_path__ + "assets/img/btn-img.b79f335d.png";